












































































































































































































































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import Dropdown from '@/shared/dropdown/dropdown.component.vue';
import Combobox from '@/shared/combobox/combobox.component.vue';
import TextField from '@/shared/text-field/text-field.component.vue';
import TextArea from '@/shared/text-area/text-area.component.vue';
import TextAreaComment from '@/shared/text-area/text-area-comment.component.vue';
import WorkItemRelated from '@/domain/work-item/work-item-related.entity';
import ButtonComponent from '@/shared/button/button.component.vue';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import FilterFields from '@/domain/project/filter-fields.entity';
import WorkItem from '@/domain/work-item/work-item.entity';
import WorkItemType from '@/domain/work-item/work-item-type.entity';
import WorkItemChildList from '@/views/work-item/work-item-child-list.component.vue';
import WorkItemModalState from '@/domain/work-item/work-item-modal-state.entity';
import WorkItemPostAggregator from '@/domain/work-item/work-item-post-aggregator.entity';
import WorkItemRules from './work-item-form.rules';
import EventErrorService from '@/domain/event/event-error.service';
import WorkItemService from '@/domain/work-item/work-item.service';
import WorkItemLatestTimestamp from '@/domain/work-item/work-item-latest-timestamp.entity';

@Component({
  components: {
    Dropdown,
    TextField,
    TextArea,
    TextAreaComment,
    ButtonComponent,
    ModalConfirm,
    WorkItemChildList,
    Combobox,
  },
})
export default class WorkItemForm extends Vue {
  @Prop() workItem!: any;

  @Prop() filterFields!: FilterFields;

  @Prop() parentWorkItems!: WorkItemRelated[];

  @Prop() dialogModal!: boolean;

  @Prop() workItemAction!: any;

  @Prop() modalFields!: WorkItemModalState;

  @Prop({ type: Boolean, default: true }) validForm !: boolean;

  @Prop({ type: Boolean, default: false }) autoFill!: boolean;

  @Prop({ default: () => [] }) projectDirectives!: any[];

  rules = new WorkItemRules();

  reprocessing: boolean = false;

  reprocessed: boolean = false;

  loadingTimestamp: boolean = false;

  private eventErrorService = new EventErrorService();

  showConfirmDisableVstsIntegrationModal: boolean = false;

  loadingDefaultTaskType: boolean = false;

  cancel() {
    this.$emit('confirmationModal');
  }

  @Watch('workItem.originalEstimate')
  onOriginalEstimateChange(): void {
    this.revalidateEffortFields('storyPointsField');
  }

  @Watch('workItem.storyPoints')
  onStoryPointsChange(): void {
    this.revalidateEffortFields('originalEstimateField');
  }

  @Watch('workItem.workItemType')
  onWorkItemTypeChange(): void {
    this.revalidateEffortFields('originalEstimateField');
    this.revalidateEffortFields('storyPointsField');
  }

  revalidateEffortFields(counterpartRef: string): void {
    this.$nextTick(() => {
      const counterpart: any = this.$refs[counterpartRef];
      if (counterpart && typeof counterpart.validate === 'function') {
        counterpart.validate();
      }
    });
  }

  isOriginalEstimateRequired(workItemType: any): boolean {
    if (!workItemType || !this.projectDirectives) return false;
    const typeDirectives = this.projectDirectives.find(
      (pd: any) => pd.workItemType && pd.workItemType.name === workItemType.name,
    );
    if (!typeDirectives || !typeDirectives.definitions) return false;
    return typeDirectives.definitions.some(
      (def: any) => def.directive
        && def.directive.name === 'REQUIRED_ORIGINAL_ESTIMATE'
        && def.activated === true,
    );
  }

  saveAndClose() {
    this.save(true);
  }

  resetValidation() {
    const { form }: any = this.$refs;
    form.resetValidation();
    this.reprocessed = false;
  }

  updateValidForm(validForm: boolean): void {
    this.$emit('update:validForm', validForm);
  }

  save(close: boolean = false) {
    const { form }: any = this.$refs;
    const valid = form.validate();
    if (!valid) return;
    if (this.workItem instanceof WorkItemPostAggregator) {
      this.workItem.assignedUserArray = this.workItem.assignedTo;
    }
    if (this.workItem.originSystem === 'VSTS' && !this.workItem.vstsIntegrationBlocked) {
      this.showConfirmDisableVstsIntegrationModal = true;
      return;
    }
    this.$emit('saveWorkItem', this.workItem, close);
  }

  reset() {
    this.$emit('close');
  }

  get workItemTypeFilter() : WorkItemType[] {
    if (this.filterFields.workItemTypesMapper.length === 0) {
      return [];
    }

    const workItemTypesWithMapping = this.filterFields.workItemTypes
      .filter(value => this.filterFields.workItemTypesMapper.indexOf(value.name) !== -1);

    const result = this.modalFields.isTask
      ? workItemTypesWithMapping.filter((value: WorkItemType) => value.definitionType === 'TASK')
      : workItemTypesWithMapping.filter(value => value.definitionType === 'AGGREGATOR');

    return result;
  }

  filterWorkItemTypesByDefinitionType(definitionType: string): WorkItemType[] {
    return this.filterFields.workItemTypes
      .filter((value: WorkItemType) => value.definitionType === definitionType);
  }

  reprocessWorkItem(): void {
    this.reprocessing = true;
    this.eventErrorService.reprocess(this.workItem.errorId).then(() => {
      this.reprocessed = true;
    }).finally(() => {
      this.reprocessing = false;
    });
  }

  changeStatus(status: string): void {
    this.workItem.status = status;
    if (status === 'DONE') {
      if (this.workItem.effortSpent === 0 && this.workItem.workItemType.definitionType === 'TASK') {
        this.workItem.concludedAt = this.workItem.createdDate;
      } else if (this.workItem.workItemType.definitionType === 'AGGREGATOR') {
        this.loadingTimestamp = true;
        WorkItemService.getChildrenTasks(this.workItem.id)
          .then((ChildrenTasks: WorkItem[]) => {
            const latestConcludedDate = ChildrenTasks
              .map(task => moment(task.concludedAt))
              .sort((a, b) => b.diff(a))[0];
            if (latestConcludedDate) {
              this.workItem.concludedAt = latestConcludedDate.format('YYYY-MM-DD');
            }
          })
          .catch(() => {
            console.error('Erro ao buscar tarefas filhas.');
          })
          .finally(() => {
            this.loadingTimestamp = false;
          });
      } else {
        this.loadingTimestamp = true;
        WorkItemService.getLatestTimetrack(this.workItem.id)
          .then((workItemTimestamp: WorkItemLatestTimestamp) => {
            const endMoment = moment(workItemTimestamp.dateTimeEnd);
            this.workItem.concludedAt = endMoment.format('YYYY-MM-DD');
          })
          .catch(() => {})
          .finally(() => {
            this.loadingTimestamp = false;
          });
      }
    }
  }

  changeWorkItemParent(status: WorkItemRelated): void {
    this.modalFields.workItemType = false;
  }

  get parentWorkItemsList() {
    const parentExists = this.parentWorkItems.some((parentItem) => {
      if (this.workItem.parent) {
        return parentItem.id === this.workItem.parent.id;
      }
      return true;
    });
    if (parentExists) {
      return this.parentWorkItems;
    }
    return [this.workItem.parent];
  }

  handleConfirmDisableVstsIntegration() {
    this.showConfirmDisableVstsIntegrationModal = false;
    this.$emit('saveWorkItem', this.workItem, false);
  }

  setWorkItemType(taskTypeId: string) {
    const match = this.workItemTypeFilter.find((it: any) => it.id === taskTypeId);
    if (match) {
      this.workItem.workItemType = match;
    }
  }

  created() {
    if (this.modalFields.isTask && this.workItemAction === 'CREATE' && this.autoFill) {
      this.loadingDefaultTaskType = true;
      WorkItemService.findDefaultTaskType(
        this.workItem.project.id,
        this.workItem.parent.workItemTypeId,
      ).then((taskTypeId: string | null) => {
        if (taskTypeId !== null) {
          this.setWorkItemType(taskTypeId);
        }
      }).catch(() => {})
        .finally(() => { this.loadingDefaultTaskType = false; });
    }
  }
}
